const menu = document.querySelector(".header__inline-menu");
if (!menu) return;

const items = menu.querySelectorAll("details");
const CLOSE_DELAY = 200; // ajuste à 250–300 si tu veux encore plus doux

items.forEach((item) => {
  let closeTimer = null;

  const openItem = () => {
    clearTimeout(closeTimer);
    // ferme les autres
    items.forEach((i) => {
      if (i !== item) i.removeAttribute("open");
    });
    item.setAttribute("open", "");
  };

  const closeItem = () => {
    closeTimer = setTimeout(() => {
      item.removeAttribute("open");
    }, CLOSE_DELAY);
  };

  item.addEventListener("mouseenter", openItem);
  item.addEventListener("mouseleave", closeItem);

  // sécurité : si on revient dans le sous-menu, on annule la fermeture
  const submenu = item.querySelector(".header__submenu, ul");
  if (submenu) {
    submenu.addEventListener("mouseenter", () => {
      clearTimeout(closeTimer);
    });
    submenu.addEventListener("mouseleave", closeItem);
  }

  // empêche le clic desktop de casser le hover
  const summary = item.querySelector("summary");
  if (summary) {
    summary.addEventListener("click", (e) => {
      if (window.matchMedia("(min-width: 990px)").matches) {
        e.preventDefault();
      }
    });
  }
});
